



















import Vue from "vue";

import { serviceModeStatusEnumLabel, ServiceModeStatusEnum } from "@/model/data/serviceMode/ServiceModeStatusEnum";

export default Vue.extend({
    data() {
        return {
            selectedItems: [],
        };
    },
    computed: {
        availableServiceModeStatus() {
            var res = [];
            Object.keys(ServiceModeStatusEnum)
                .filter((k) => typeof ServiceModeStatusEnum[k as any] === "number")
                .forEach((k) => {
                    if (ServiceModeStatusEnum[k] >= 0) res.push({ label: this.$t(serviceModeStatusEnumLabel(ServiceModeStatusEnum[k])), value: ServiceModeStatusEnum[k as any] });
                });
            return res;
        },
    },
    watch: {
        selectedItems() {
            this.$emit("input", this.selectedItems);
        },
    },
});
